import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { RichText } from 'prismic-reactjs'
import Layout from '../components/layout'
import LegalDoc from '../components/LegalDoc'
import SEO from '../components/seo'

export const query = graphql`
  query LegalQuery($uid: String) {
    prismic {
      allLegals(uid: $uid) {
        edges {
          node {
            title
            body
            updated_date
          }
        }
      }
    }
  }
`

const LegalPageTemplate = ({ data }) => {
  const doc = data.prismic.allLegals.edges.slice(0, 1).pop()
  if (!doc) return null

  return (
    <Layout>
      <SEO
        title={RichText.asText(doc.node.title)}
        meta={[
          {
            name: `robots`,
            content: `noindex`
          }
        ]}
      />
      <LegalDoc doc={doc.node} />
    </Layout>
  )
}

LegalPageTemplate.propTypes = {
  data: PropTypes.object.isRequired
}

export default LegalPageTemplate
